import { render, staticRenderFns } from "./gj-modal.vue?vue&type=template&id=44498fae&scoped=true&"
import script from "./gj-modal.vue?vue&type=script&lang=js&"
export * from "./gj-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gj-modal.vue?vue&type=style&index=1&id=44498fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44498fae",
  null
  
)

export default component.exports